import { Form as FormikForm } from 'formik';
import styled from 'styled-components/macro';
import { layout, radius, shadow } from '../../../theme/tokens';
import * as common from '../../common/elements/Form';

export const Form = styled(FormikForm)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  /* flex-start, not center, so overflowing content stays scrollable */
  justify-content: flex-start;
  width: calc(100% - 2 * ${layout.gutter});
  /* keep tall forms inside the viewport on small screens */
  max-height: calc(100vh - 2 * ${layout.gutter});
  overflow-y: auto;
  background: ${({ theme }) => theme.appBackground};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.lg};
  ${common.ModalScreenWidthMQs}
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
